module.exports = __webpack_public_path__ + "src/img/sportIconOn.41e80637.svg";